const binding = { modules: {}, dataActions: {} };

    (binding.modules['hobart-partstream-parts'] = {
        c: () => require('partner/modules/hobart-partstream-parts/hobart-partstream-parts.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hobart-partstream-parts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hobart-partstream-parts'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };